import { ClipboardList, Tag } from 'lucide-react';

export enum MerchantTab {
  Applications = 'applications',
  Catalog = 'catalog',
}

export const MERCHANT_TAB_KEYS = [
  MerchantTab.Catalog,
  MerchantTab.Applications,
] as const;

export const isMerchantTab = (value: string): value is MerchantTab =>
  (MERCHANT_TAB_KEYS as readonly string[]).includes(value);

export const MERCHANT_TABS = [
  {
    icon: Tag,
    key: MerchantTab.Catalog,
    labelKey: 'pages.merchant.tabs.catalog' as const,
  },
  {
    icon: ClipboardList,
    key: MerchantTab.Applications,
    labelKey: 'pages.merchant.tabs.applications' as const,
  },
] as const;
